/** Chave de sessionStorage marcando que o carrinho ativo veio de um link compartilhado. */
export const SHARED_CART_SESSION_FLAG = "dt_carrinho_compartilhado";

export function buildShareUrl(orderFormId: string, origin: string): string {
  const url = new URL("/carrinho-compartilhado", origin || "https://example.com");
  url.searchParams.set("orderFormId", orderFormId);
  // Normaliza espaços: URLSearchParams usa '+', mas esperamos '%20'
  const urlString = url.toString().replace(/\+/g, "%20");
  // Se `origin` veio vazio (fallback de teste/SSR sem window.location), a URL
  // relativa ainda é útil -- mas em produção `origin` sempre vem de
  // `location.origin`, então o host acima nunca aparece de verdade.
  return origin ? urlString : `${url.pathname}${url.search.replace(/\+/g, "%20")}`;
}

export function parseSharedOrderFormId(
  search: Record<string, unknown>,
): string | undefined {
  const value = search.orderFormId;
  return typeof value === "string" && value.length > 0 ? value : undefined;
}
